import { useCallback, useMemo } from "react"
import { TimeOperations, useHeatMapGraphOption } from "./options"
import { useHeatMapGraphModel } from "./model"
import { numericValueFormat } from "../../common"

type useHeatMapGraphRenderOptionProps<T> = {
	graphOption: ReturnType<typeof useHeatMapGraphOption<T>>
	graphData: ReturnType<typeof useHeatMapGraphModel<T>>
}
export const useHeatMapGraphRenderOption = <T,>({
	graphOption: {
		valueDef, by
	},
	graphData
}: useHeatMapGraphRenderOptionProps<T>) => {
	const toolTipFormatter = useCallback(
		(params: {
			data: number[]
		}) => {
			const operation = TimeOperations[by]
			if (!operation) return ''
			const label = operation.toolTipLabel
			if (params.data.length < 3) return ''
			const x = label.x[params.data[0]]
			const y = label.y[params.data[1]]
			const value = params.data[2]
      if (value === undefined || value === null) return ''
			return `${y} ${x}<br/>${numericValueFormat(value, 1, valueDef?.unit)}`
		},
		[by, valueDef]
	)
	const { xAxis, yAxis } = useMemo(
		() => {
			const label = graphData?.axisLabels
			const xAxis = [{
				type: 'category',
				axisTick: { show: false },
				splitArea: { show: true },
				data: label?.x
			}]
			const yAxis = [{
				type: 'category',
				axisTick: { show: false },
				splitArea: { show: true },
				inverse: true,
				data: label?.y
			}]
			return { xAxis, yAxis }
		},
		[graphData?.axisLabels]
	)
	return {
		//animation: false,
		tooltip: {
			trigger: 'item',
			axisPointer: {
				type: 'shadow',
			},
			formatter: toolTipFormatter
		},
		grid: {
			left: 10,
			right: 10,
			top: 0,
			bottom: 10,
			containLabel: true
		},
		xAxis,
		yAxis,
		visualMap: {
			show: false,
			calculable: true,
			min: 0,
			max: graphData?.maxValue
		},
		series: [{
			type: 'heatmap',
			label: {
				show: true
			},
			emphasis: {
				itemStyle: {
					shadowBlur: 10,
					shadowColor: 'rgba(0, 0, 0, 0.5)'
				}
			},
			data: graphData?.values ?? [],
		}],
		textStyle: {
			fontFamily: 'Noto Sans JP,sans-serif'
		}
	}
}